import { useAppState } from "../context/appStateContext"
import useQueryParams from "./useQueryParams"

const useLastExpiredWasUltimate = (): boolean => {
  const { state } = useAppState()
  const queryParams = useQueryParams()

  return (
    queryParams.lastExpiredSubscriptionWasUltimate ||
    state.productData?.lastExpiredSubscriptionWasUltimate === true
  )
}

export default useLastExpiredWasUltimate
